import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import * as animations from "@styles/emotion-styles/animations";
import * as colors from "@styles/emotion-styles/colors";
import * as dimensions from "@styles/emotion-styles/dimensions";
import * as timing from "@styles/emotion-styles/timing";

export const item = css`
  display: flex;
`;

export const iconContainer = css`
  @media (max-width: ${dimensions.tablet}) {
    flex-grow: 0;
  }
`;

export const accordionContainer = css`
  ${iconContainer};
  text-align: end;
`;

export const button = css`
  cursor: pointer;
  width: 100%;
  padding-bottom: 1rem;
  &:not(:first-of-type) {
    padding-top: 2.25rem;
    border-top: 1px solid ${colors.grey.lightFamily.normal};
  }
`;

export const content = {
  base: css`
    overflow: hidden;
    transition: max-height ${timing.moderate} ${animations.easeInOutCubic};
    max-height: 0rem;
  `,
  isActive: css`
    &&& {
      transition-duration: ${timing.slow};
      max-height: 20rem;
    }
  `,
};

export const indicator = css`
  text-align: end;
`;

export const icon = css`
  margin-top: 0.5rem;
`;

export const text = css`
  &:first-letter {
    text-transform: capitalize;
  }

  @media (max-width: ${dimensions.tablet}) {
    && {
      margin-bottom: 0.5rem;
    }
  }
`;

export const iconStack = css`
  font-size: 2.5rem;
`;

export const iconBackgroundPath = css`
  color: ${colors.grey.lightFamily.light};
`;

export const iconPath = (theme: Theme) => css`
  color: ${theme.text.body};
`;
